// components/LSSF/TricycleApplicationsList.jsx
import React from 'react';
import BaseList from './BaseList';

const TricycleApplicationsList = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'age', label: 'Age' },
    { key: 'aadhar_number', label: 'Aadhar Number' },
    { key: 'parent_spouse_name', label: 'Parent/Spouse Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
    { key: 'disability_info', label: 'Disability Info' },
  ];

  return (
    <BaseList
      title="Tricycle Assistance Applications"
      apiEndpoint="/api/v1/mail/tricycle-form"
      columns={columns}
      addButtonLink="/dashboard/lssf/add-tricycle-application"
      addButtonText="Add Tricycle Application"
    />
  );
};

export default TricycleApplicationsList;